module.exports = __webpack_public_path__ + "static/img/other.82f339ea.png";